import DOMPurify from 'dompurify';

/**
 * Fungsi untuk membersihkan konten HTML dari ancaman XSS.
 * @param {string} dirty - String HTML yang berpotensi berbahaya.
 * @returns {string} - String HTML yang sudah dibersihkan dan aman untuk dirender.
 */
export const sanitizeHtml = dirty => {
  if (typeof dirty !== 'string') {
    // Kembalikan string kosong jika input bukan string
    return '';
  }
  return DOMPurify.sanitize(dirty);
};
